import { Injectable } from '@angular/core';
import { CheckPriceOrder } from 'app/models/order/check-price-order/check-price-order';
import { Order } from 'app/models/order/order';
import { ChangedPriceProduct } from 'app/models/product/changed-price-product/changed-price-product';
import { CheckPriceProduct } from 'app/models/product/check-price-product/check-price-product';
import { CartService } from 'app/services/cart/cart.service';
import { OrderService } from 'app/services/order/order.service';


@Injectable({
  providedIn: 'root',
})
export class PriceHelper {
  constructor(
    private _orderService: OrderService,
    private _cartService: CartService
  ) { }

  checkOrderPrices(order: Order): Promise<ChangedPriceProduct[]> {
    const changedItems: ChangedPriceProduct[] = [];

    return new Promise<any[]>((resolve, reject) => {
      this._orderService.checkPricesByOrderId(order.id).subscribe((data: any) => {

        const changedPrices: ChangedPriceProduct[] = data.data.map(e => ChangedPriceProduct.fromJson(e));

        for (var index = 0; index <= changedPrices.length - 1; index++) {
          var product: ChangedPriceProduct = changedPrices[index];

          var orderProduct = order.items.find(e => e.productId == product.orderItem.productId && e.classificationId == product.orderItem.classificationId);
          if (orderProduct != null && orderProduct.price != product.newPrice)
            changedItems.push(product);
        }

        resolve(changedItems);
      });
    });

  }

  checkItemsPrices(paymentReceiptForm: number, receivingCondition: number): Promise<ChangedPriceProduct[]> {
    const changedItems: ChangedPriceProduct[] = [];

    const orderToCheck = new CheckPriceOrder(paymentReceiptForm, receivingCondition);
    return new Promise<ChangedPriceProduct[]>((resolve, reject) => {
      this._orderService.checkPricesByItem(orderToCheck).subscribe((data) => {

        // Insere na lista produtos com problemas de preço
        for (let index = 0; index <= data.data.prices.length - 1; index++) {
          var product: ChangedPriceProduct = ChangedPriceProduct.fromJson(data.data.prices[index]);
          changedItems.push(product);
        }

        // Insere na lista produtos com problemas de estoque
        for (let index = 0; index <= data.data.stockProducts.length - 1; index++) {
          var stockProblemProduct = data.data.stockProducts[index];

          // Verifica se o produto já existe na lista
          var repeatedItemIndex = changedItems.findIndex((value) => value.orderItem.productId == stockProblemProduct.PRODUCTCODE && value.orderItem.classificationId == stockProblemProduct.PRODUCTCLASCODE)

          var product: ChangedPriceProduct = ChangedPriceProduct.fromJson(data.data.stockProducts[index]);

          if (repeatedItemIndex != -1) {
            // Se é repetido, atualiza o valor e substitui o elemento
            product.newPrice = changedItems[repeatedItemIndex].newPrice;
            changedItems[repeatedItemIndex] = product;
          } else {
            changedItems.push(product);
          }
        }

        resolve(changedItems);
      }, (error) => {
        reject(error.error.message);
      });
    });
  }
}
